import { Languages } from "../common/constants";

/** Map minute offset (may be negative or >1440) to 0–1439 for display. */
export const normalizeMinuteInDay = (value: number): number =>
    ((value % 1440) + 1440) % 1440

/** How many calendar days after the visit date the end falls on, and minutes 0–1439 on that day (for minuteToTime). */
export function visitEndToCalendarDayAndMinutes(
    startMinutes: number,
    endMinutes: number,
): { endDayOffset: number; endMinuteInDay: number } {
    if (endMinutes === 1440) {
        return { endDayOffset: 1, endMinuteInDay: 0 }
    }
    if (endMinutes > 1440) {
        return {
            endDayOffset: Math.floor(endMinutes / 1440),
            endMinuteInDay: endMinutes % 1440,
        }
    }
    if (endMinutes <= startMinutes && startMinutes > 0) {
        return { endDayOffset: 1, endMinuteInDay: endMinutes }
    }
    return { endDayOffset: 0, endMinuteInDay: endMinutes }
}

export const minuteToTime = (value: number, is12h?: boolean, upperCase?: boolean, language?: string) => {
    // type = true -> 12h ; type = false -> 24h
    const normalized = normalizeMinuteInDay(value)
    let tt = "";
    const hour24 = Math.floor(normalized / 60) % 24;
    let h: any = (hour24 > 9) ? hour24 : ('0' + hour24);
    let m: any = normalized % 60;
    m = (m > 9) ? m : ('0' + m);

    if (is12h) {
        const isPm = hour24 >= 12;
        const hour12 = hour24 % 12 === 0 ? 12 : hour24 % 12;

        if (upperCase) {
            tt = isPm ? ((language === Languages.en) ? 'PM' : 'م') : ((language === Languages.en) ? 'AM' : 'ص');
        } else {
            tt = isPm ? 'pm' : 'am';
        }

        h = (hour12 > 9) ? hour12 : ('0' + hour12);
        return (h + ':' + m + ' ' + tt);
    } else {

        return (h + ':' + m);
    }
};